import { FC, createContext, useContext, useMemo } from 'react';
import { useGetWhatsAppInfobipLocales } from '../../hooks/useGetWhatsAppInfobipLocales';
import { selectIsWhatsAppInfobipLocalesEnabled } from 'core/userContext';
import { useSelector } from 'react-redux';

type WhatsAppInfobipLocalesContextState = {
  whatsAppInfobipLocales: {
    value: string;
    label: string;
  }[];
};

const defaultValues: WhatsAppInfobipLocalesContextState = {
  whatsAppInfobipLocales: [],
};

export const WhatsAppInfobipLocalesContext =
  createContext<WhatsAppInfobipLocalesContextState>(defaultValues);
export const useWhatsAppInfobipLocalesContext = () => useContext(WhatsAppInfobipLocalesContext);

export const WhatsAppInfobipLocalesContextProvider: FC<React.PropsWithChildren> = ({
  children,
}) => {
  const isWhatsAppInfobipLocalesEnabled = useSelector(selectIsWhatsAppInfobipLocalesEnabled);

  const { data } = useGetWhatsAppInfobipLocales({
    skip: !isWhatsAppInfobipLocalesEnabled,
  });

  const whatsAppInfobipLocales = useMemo(
    () =>
      data?.map(({ code, displayName }) => ({
        value: code,
        label: displayName,
      })) ?? [],
    [data],
  );

  return (
    <WhatsAppInfobipLocalesContext.Provider
      value={{
        whatsAppInfobipLocales,
      }}
    >
      {children}
    </WhatsAppInfobipLocalesContext.Provider>
  );
};
